import { ResponseErrorHandling } from "../../../../helper";
import commonService from "../../../../services/Common/service";
import { CommonActionTypes } from "../../../action-types";

export const getSingleCoin = (currency, range = "24H") => async (dispatch) => {
  dispatch({ type: CommonActionTypes.PENDING, payload: true });

  try {
    const res = await commonService.get(`/client/coingecko/coins/${currency}`, {
        params: { "range" : range }
    });
    
    return res.data;
  } catch (err) {
    const message = err.response?.data?.message || err.message || err.toString();

    ResponseErrorHandling(err.response, dispatch);

    dispatch({
      type: CommonActionTypes.REJECTED,
      payload: { message, isError: true },
    });
    
    throw err;
  } finally {
    // Reset pending spinner animations
    dispatch({ type: CommonActionTypes.RESET, payload: true });
  }
};
